import { Constants } from './../../_helpers/constants-handle';
import { Component, OnInit, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { DrawService } from '../../_services/draw.service';
import { AlertService } from '../../_services/alert.service';
import { AuthenticationService, CommonService } from 'src/app/_services';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: '.myTicketwrapper',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MyTicketsComponent implements OnInit, OnDestroy {

  playerTicketDataSubscription: any;
  userInfo: any;
  myTicketsMap: any;
  myTickets = [];
  gameList = [{ gameCode: 'All', dispName: 'All', url: '/dge/lobby' }];
  gameSelect = '';
  sortBy = '';
  sortByMap = [];
  userInfoLocalSubscription: any;
  p: number = 1;
  ticketTable = true;
  engineName = Constants.DRAW_ENGINE;
  clientCode = Constants.CLIENT_CODE;
  constructor(
    private drawService: DrawService,
    private alertService: AlertService,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private translate: TranslateService,
  ) {
    this.myTicketsMap = Constants.MY_TICKETS_STATUS_MAP;
    let tempUser: any = {};
    tempUser = JSON.parse(localStorage.getItem('drawGameUserInfo'));
    this.gameList = [];
    if(tempUser.aliasName == "www.winlot.in" && Constants.CLIENT_PLAYERWISE_GAMES_MAPPING[tempUser.playerid]) {
      this.engineName = Constants.CLIENT_PLAYERWISE_GAMES_MAPPING[tempUser.playerid].clientWiseGameEngine;
    } else {
      this.engineName = Constants.DRAW_ENGINE;
    }
    // Constants.CLIENT_GAMES_MAPPING[Constants.CLIENT_CODE][Constants.DRAW_ENGINE].forEach(element => {
    Constants.CLIENT_GAMES_MAPPING[Constants.CLIENT_CODE][this.engineName].forEach(element => {
      this.gameList.push({
        gameCode: element,
        dispName: Constants.GAME_DATA[Constants.DRAW_ENGINE][element].dispName,
        url: '/dge/' + Constants.GAME_DATA[Constants.DRAW_ENGINE][element].dispName.toLowerCase().replace(/[ /]/g, '-'),
      });
    });
    this.sortByMap = [
      { 'code': 'txn', 'name': 'Txn. Time' },
      { 'code': 'drawdate', 'name': 'Draw Date' },
      { 'code': 'status', 'name': 'Status' }
    ];
    if (this.drawService.orderingTicketList.gameCode != '') {
      this.gameSelect = this.drawService.orderingTicketList.gameCode;
    } else {
      this.gameSelect = this.gameList[0].gameCode;
    }
    if (this.drawService.orderingTicketList.orderBy != '') {
      this.sortBy = this.drawService.orderingTicketList.orderBy;
    } else {
      this.sortBy = this.sortByMap[0].code;
    }
  }

  ngOnInit() {
    this.commonService.addEngineClass();
    this.userInfoLocalSubscription = this.authenticationService.subscribeuserInfoLocal().subscribe((response) => {
      this.userInfo = response;
      this.commonService.iframe_resize();
    });
    this.getTicketList('init');
    this.authenticationService.getUserInfoLocal();
    this.commonService.iframe_resize();
  }

  getTicketList(from) {
    let temp = {};
    temp['gameCode'] = this.gameSelect;
    temp['orderBy'] = 'desc';
    temp['pageSize'] = 100;
    temp['pageIndex'] = 0;
    temp['isBingoEnable'] = false,
    this.playerTicketDataSubscription = this.drawService.fetchPlayerTicketList(temp).subscribe((response: any) => {
      this.myTickets = [];
      if (typeof response != 'undefined' && typeof response.data != 'undefined' && response.data.responseCode == 0) {
        response.data.responseData.forEach(element => {
          element.ticketList.forEach(element1 => {
            element1.gameCode = element.gameCode;
            element1.gameName = element.gameName;
          });
          this.myTickets = this.myTickets.concat(element.ticketList);
        });
        if (this.myTickets == null || this.myTickets.length == 0) {
          this.ticketTable = false;
          // this.alertService.error("No Tickets Available!!!");
        } else {
          this.ticketTable = true;
          this.sortMeBy(from);
        }
      } else if (typeof response != 'undefined') {
        this.alertService.error(this.translate.instant(`error.dge.${response.responseCode}`));
      }
      this.commonService.iframe_resize();
    });
  }

  purchaseTicketUrl() {
    this.gameList.forEach(element => {
      if (element.gameCode == this.gameSelect) {
        this.router.navigate([element.url]);
      }
    });
    this.commonService.iframe_resize();
  }

  sortMeBy(from) {
    this.drawService.orderingTicketList.gameCode = this.gameSelect;
    this.drawService.orderingTicketList.orderBy = this.sortBy;
    this.myTickets.sort(this.getSortOrder(this.sortBy));
    if (from == 'view') {
      this.p = 1;
      this.drawService.orderingTicketList.currentTab = 1;
    } else {
      this.p = this.drawService.orderingTicketList.currentTab;
    }
    this.commonService.iframe_resize();
  }

  getSortOrder(prop) {
    if (prop == 'status') {
      return (a, b) => {
        let val1 = a.ticketDetails.winstatus;
        let val2 = b.ticketDetails.winstatus;
        if (val1 < val2) {
          return 1;
        } else if (val1 > val2) {
          return -1;
        }
        return 0;
      }
    }
    else if (prop == 'drawdate') {
      return (a, b) => {
        let val1 = new Date(this.drawService.changeDateFormat(a.drawDetails.drawDateTime)).getTime();
        let val2 = new Date(this.drawService.changeDateFormat(b.drawDetails.drawDateTime)).getTime();
        if (val1 < val2) {
          return 1;
        } else if (val1 > val2) {
          return -1;
        }
        return 0;
      }
    }
    else if (prop == 'betvalue') {
      return (a, b) => {
        let val1 = a.ticketDetails.saleAmount;
        let val2 = b.ticketDetails.saleAmount;
        if (val1 < val2) {
          return 1;
        } else if (val1 > val2) {
          return -1;
        }
        return 0;
      }
    }
    else {
      return (a, b) => {
        let val1 = new Date(this.drawService.changeDateFormat(a.transactionDate)).getTime();
        let val2 = new Date(this.drawService.changeDateFormat(b.transactionDate)).getTime();
        if (val1 < val2) {
          return 1;
        } else if (val1 > val2) {
          return -1;
        }
        return 0;
      }
    }
  }

  ngOnDestroy(): void {
    if (typeof this.userInfoLocalSubscription != 'undefined') {
      this.userInfoLocalSubscription.unsubscribe();
    }
    if (typeof this.playerTicketDataSubscription != 'undefined') {
      this.playerTicketDataSubscription.unsubscribe();
    }
    this.commonService.iframe_resize();
  }

  changeDateFormat(date) {
    if (typeof date != 'undefined' && date != null)
      return this.drawService.changeDateFormat(date);
  }

  loadTicket(ticketNumber, drawId) {
    this.drawService.fromMyTickets = true;
    this.router.navigate(['/dge/view-ticket/' + ticketNumber + '/0'], { fragment: drawId });
  }

  pageChange(event) {
    this.p = event;
    this.drawService.orderingTicketList.currentTab = this.p;
    this.commonService.iframe_resize();
  }

  numberWithSpaces(x) {
    // Parse the input as a float
    let number = parseFloat(x);
    if (number % 1 === 0) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      let formattedNumber = number.toFixed(2).toString().replace(".", ",");
      return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  }

}
